import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox", "fill"];
import React from 'react';

var PartialCircle = function PartialCircle(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 32 32' : _ref$viewBox,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#2F8255' : _ref$fill,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14.5",
    fill: "none",
    stroke: fill,
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28475 29.4203L24.7152 2.5797C22.2078 0.948007 19.2146 0 16 0C14.9655 0 13.9539 0.0981833 12.974 0.28574L12.3417 0.420146C5.26808 2.07465 0 8.42211 0 16C0 17.0346 0.0981944 18.0462 0.285772 19.0261L0.420107 19.6581C1.37273 23.7311 3.88128 27.2055 7.28475 29.4203Z",
    fill: fill
  }));
};

PartialCircle.displayName = 'PartialCircle';
export default PartialCircle;